import { useTranslation } from 'react-i18next';

const STORY_IMG = '/images/home/1.jpg';

export default function StorySection() {
  const { t } = useTranslation();
  return (
    <section id="story" className="story section section--soft">
      <div className="container story__inner">
        <div className="story__visual reveal">
          <img src={STORY_IMG} alt="Ionian Sea seen from Ithaca" loading="lazy" />
        </div>
        <div className="story__copy">
          <p className="eyebrow reveal">{t('story.eyebrow')}</p>
          <h2 className="reveal">{t('story.title')}</h2>
          <p className="lede reveal">{t('story.body')}</p>

          <dl className="story__meta reveal">
            <div>
              <dt>{t('story.stats.suites')}</dt>
              <dd>{t('story.stats.suitesValue')}</dd>
            </div>
            <div>
              <dt>{t('story.stats.village')}</dt>
              <dd>{t('story.stats.villageValue')}</dd>
            </div>
            <div>
              <dt>{t('story.stats.port')}</dt>
              <dd>{t('story.stats.portValue')}</dd>
            </div>
          </dl>
        </div>
      </div>
    </section>
  );
}
